import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ChatType,
  VsAssociateEvent,
  chatActions,
  useAppDispatch,
  useReadAssociateEvent,
} from '@vs-online-only-app/state';
import { Alert, Snackbar, Link as MuiLink } from '@mui/material';

type Props = {
  endedConversationEvent: VsAssociateEvent;
  autoEnded: boolean;
};

const EndedConversationBanner: FC<Props> = ({
  endedConversationEvent,
  autoEnded,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const readAssociateEventMutation = useReadAssociateEvent();
  const { conversation } = endedConversationEvent;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      readAssociateEventMutation.mutateAsync(endedConversationEvent.id);
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [endedConversationEvent, readAssociateEventMutation]);

  useEffect(() => {
    setIsVisible(true);
  }, [conversation]);

  const handleViewChat = () => {
    dispatch(chatActions.setSelectedChatType(ChatType.Archived));
    dispatch(chatActions.setSelectedConversation(conversation));
    navigate(`/chats?id=${conversation.id}`);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity="info"
        action={
          <MuiLink component="button" onClick={handleViewChat}>
            View chat
          </MuiLink>
        }
        sx={{ alignItems: 'center' }}
      >
        The chat with{' '}
        <strong>{conversation?.conversationStarter.firstName}</strong> has been{' '}
        {autoEnded ? 'automatically ended due to inactivity' : 'ended'} and
        moved to <strong>Archived chats</strong>.
      </Alert>
    </Snackbar>
  );
};

export default EndedConversationBanner;
